import React from "react";

/**
 * Manual-style section divider used at the top of each major App section.
 *
 * Three visual modes (selected by which props are passed):
 *   - number only        → "01 ─────────────"   (ConversionResults chapters)
 *   - title only         → "Tune ─────────────" (pre-conversion controls)
 *   - number + title     → "01 Preview ───────" (preview with spec chips)
 *
 * The optional `id` is attached to the visible wrapper for in-page anchor
 * links (jump-nav between sections). `scroll-mt-20` keeps the section title
 * below the sticky header when scrolled to via anchor.
 *
 * The optional `toolbar` is right-aligned and typically holds buttons or
 * spec chips. The horizontal rule flexes between the leading element and
 * the toolbar so it always fills the available width.
 */
const SectionRule: React.FC<{
  number?: string;
  title?: string;
  id?: string;
  toolbar?: React.ReactNode;
}> = ({ number, title, id, toolbar }) => (
  <div
    id={id}
    className="flex items-center gap-4 mb-6 scroll-mt-20 flex-wrap"
  >
    {number && (
      <span
        aria-hidden
        className="font-display text-xl font-extrabold text-brick tabular-nums"
      >
        {number}
      </span>
    )}
    {title && (
      <h2 className="font-display text-xl sm:text-2xl font-extrabold text-ink tracking-tight">
        {title}
      </h2>
    )}
    <span aria-hidden className="h-px flex-1 bg-ink/15 min-w-6" />
    {toolbar}
  </div>
);

export default SectionRule;
